import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNlFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53707)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9989 19.5402H-0.000976562V9.48271C-0.000976562 9.00664 0.385058 8.62061 0.861131 8.62061H49.1369C49.613 8.62061 49.999 9.00664 49.999 9.48271L49.9989 19.5402Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1368 41.379H0.861131C0.385058 41.379 -0.000976562 40.993 -0.000976562 40.5169V30.4595H49.9989V40.5169C49.9989 40.9931 49.6129 41.379 49.1368 41.379Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9989 19.54H-0.000976562V30.459H49.9989V19.54Z",
					fill: "#F3F3F3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53707",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgNlFlag);
export { ForwardRef as ReactComponent };
